<template>
  <div class="batch-import-page">
    <crumb-tit>
      <span slot="breadTit">{{ $t('message["710"]') }}</span>
      <span slot="secondTit">{{ $t('message["710"]') }}</span>
    </crumb-tit>
    <a-tabs
      :active-key="activeKey"
      tab-position="top"
      :animated="false"
      @change="tabCallback"
    >
      <a-tab-pane
        key="1"
        :tab="historyTaskTit"
      >
        <!-- <table-list ref="tableList" /> -->
      </a-tab-pane>
      <a-tab-pane
        key="2"
        :tab="createTask"
        force-render
      >
        <!-- <Create /> -->
      </a-tab-pane>
    </a-tabs>
    <router-view />
  </div>
</template>

<script>
import CrumbTit from '@/components/pc/config/CrumbTit'

export default {
  components: {
    CrumbTit
  },

  data () {
    return {
      activeKey: '1'
    }
  },
  computed: {
    createTask () {
      return this.$t('message["125"]')
    },
    historyTaskTit () {
      return this.$t('message["593"]')
    }
  },
  watch: {
    $route: {
      handler (to) {
        let key = '1'
        switch (to.name) {
          case 'configImportList':
            key = '1'
            break
          default:
            key = '2'
            break
        }
        this.activeKey = key
      },
      immediate: true
    }
  },

  methods: {
    tabCallback (key) {
      // this.activeKey = key
      let routeName
      if (key === '1') {
        routeName = 'configImportList'
      } else if (key === '2') {
        routeName = 'configImportFirst'
      }
      this.$router.push({
        name: routeName
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .batch-import-page::v-deep {
    .ant-tabs-nav-wrap {
      margin-top: 24px;
      border-top: solid 1px #ebebeb;
    }
    .ant-tabs-bar {
      border-bottom: 0 none;
    }
    .ant-tabs-nav {
      .ant-tabs-tab {
        margin-right: 16px;
        padding: 8px 2px;
        font-size: 18px;
        font-weight: bold;
        line-height: 32px;
      }
    }
    margin-bottom: 40px;
  }
</style>
